import { render, staticRenderFns } from "./AudiogramRegionIcon.vue?vue&type=template&id=05286b16"
import script from "./AudiogramRegionIcon.vue?vue&type=script&lang=js"
export * from "./AudiogramRegionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports